export default function hex2dec(hex: string): number {
  return parseInt(hex, 16);
}
